export default "__VITE_ASSET__CNY$52sZ__"